module.exports = __webpack_public_path__ + "media/categories/4019-db5bc4f9.svg";